import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../../context";
import { momentDate } from "../../../utils";
import { Button, Card, Row, Col, Tabs, Tab } from "react-bootstrap";
import { Spin } from "antd";
import toast from "react-hot-toast";
import axios from "axios";
import { ServiceUrl } from "../../../utils/serviceUrl";

const TrackPayment = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [activeKey, setActiveKey] = useState("completed");
  const [buttonDisableTime, setButtonDisableTime] = useState({});

  useEffect(() => {
    /* if (props.profile.student_uuid) loadData(props.profile.student_uuid); */
    console.log(props.dataSource);
    if (props.dataSource && props.dataSource.length > 0) {
      loadData(props.dataSource);
    }
  }, [props.dataSource]);

  useEffect(() => {
    // Load the stored disable time from localStorage when the page is loaded
    const storedDisableTime = JSON.parse(
      localStorage.getItem("buttonDisableTime") || "{}"
    );
    setButtonDisableTime(storedDisableTime);
  }, []);

  const loadData = (datas) => {
    try {
      context.setLoader(true);
      var form = new FormData();
      form.append("user_id", datas[0].user_id);
      axios.post(ServiceUrl.UG.GET_STUDENT_ORDERS, form).then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        } else {
          setDataList([]);
          setDataView([]);
          toast.error(res["data"].message || "Error");
        }
        context.setLoader(false);
      });
    } catch (error) {
      context.setLoader(false);
    }
  };

  useEffect(() => {
    let d = [];
    if (dataList.length > 0) {
      d = dataList.filter(
        (item) => item.status === (activeKey === "completed" ? "1" : "0")
      );
    }
    setDataView(d);
  }, [activeKey, dataList]);

  const handleTrackStatus = (item) => {
    const order_id = item.order_id;

    if (
      buttonDisableTime[order_id] &&
      buttonDisableTime[order_id] > Date.now()
    ) {
      toast.error("You can only track the status once every 30 minutes.");
      return;
    }

    setLoader(true);

    const form = new FormData();
    form.append("order_id", item.order_id);

    axios
      .post(ServiceUrl.UG.TRACK_PAYMENT_BY_ORDER_UG, form)
      .then((res) => {
        if (res.data.status === "1") {
          toast.success(res.data.message || "Updated");
          // Disable the button and start countdown for 30 minutes
          /*         const disableUntil = Date.now() + 30 * 60 * 1000; // 30 minutes from now

          // Update state and localStorage
          setButtonDisableTime((prev) => {
            const updatedTime = { ...prev, [order_id]: disableUntil };
            localStorage.setItem(
              "buttonDisableTime",
              JSON.stringify(updatedTime)
            );
            return updatedTime;
          }); */
          loadData(props.dataSource);
        } else {
          /*    const disableUntil = Date.now() + 30 * 60 * 1000; // 30 minutes from now

          // Update state and localStorage
          setButtonDisableTime((prev) => {
            const updatedTime = { ...prev, [order_id]: disableUntil };
            localStorage.setItem(
              "buttonDisableTime",
              JSON.stringify(updatedTime)
            );
            return updatedTime;
          }); */
          toast.error(res.data.message || "Error");
          loadData(props.dataSource);
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
        toast.error("An error occurred while updating the order.");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  // Format time remaining for countdown
  const formatTimeRemaining = (timeLeft) => {
    const minutes = Math.floor(timeLeft / 60000);
    const seconds = Math.floor((timeLeft % 60000) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div data-aos="fade-up">
      <div className="container-fluid py-3">
        <Spin spinning={loader}>
          {props.dataSource && (
            <div data-aos="fade-in">
              <div className="my-3"></div>
              <Tabs
                activeKey={activeKey}
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={(k) => setActiveKey(k)}
              >
                <Tab eventKey="completed" title="Completed Orders" />
                <Tab eventKey="cancelled" title="Cancelled Orders" />
              </Tabs>

              {/* Display orders as receipt */}
              <Row className="g-3">
                {dataView.map((item, i) => {
                  const order_id = item.order_id;
                  const timeRemaining = buttonDisableTime[order_id]
                    ? buttonDisableTime[order_id] - Date.now()
                    : 0;
                  const isDisabled = timeRemaining > 0;

                  return (
                    <Col key={i} xs={12} sm={6} md={4}>
                      <Card className="receipt-card p-3">
                        <Card.Body>
                          <Card.Title className="text-center">
                            Order #{item.order_id}
                          </Card.Title>
                          <Card.Text>
                            <strong>Date: </strong>
                            {momentDate(item.created_on, "DD-MM-YYYY hh:mm")}
                          </Card.Text>
                          <Card.Text>
                            <strong>Amount: </strong>
                            {item.amount}
                          </Card.Text>
                          <Card.Text>
                            <strong>Payment Ref: </strong>
                            {item.tracking_id}
                          </Card.Text>
                          <Card.Text>
                            <strong>Status: </strong>
                            {item.payment_status}
                          </Card.Text>
                          {parseInt(item.status) === 0 &&
                            parseInt(item.payment_completed) === 0 && (
                              <>
                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={() => handleTrackStatus(item)}
                                  disabled={isDisabled}
                                >
                                  {isDisabled
                                    ? "Tracking in progress"
                                    : "Track Status"}
                                </Button>
                                {isDisabled && (
                                  <span className="ms-3 text-danger">
                                    {formatTimeRemaining(timeRemaining)}{" "}
                                    remaining
                                  </span>
                                )}
                              </>
                            )}
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </div>
          )}
        </Spin>
      </div>
    </div>
  );
};

export default TrackPayment;
